import React from 'react';
import classNames from 'classnames';
import { ContainerQuery } from 'react-container-query';


const query = {
  'lg': { minWidth: 600 },
};

const PlayIcon = props => (
  <ContainerQuery query={query}>
    {params => (
      <div className={classNames({ ...params, 'play-icon': true, thumbnail: props.thumbnail })} />
    )}
  </ContainerQuery>
);

export default PlayIcon;



// WEBPACK FOOTER //
// ./src/components/PlayIcon.js